import { HomeRoutePath } from 'shared/constants/router';

import { Link } from './components/Link';

import type { LinkProps } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

export interface LogoLinkProps
  extends PropsWithChildren,
    Pick<LinkProps, 'sx'> {
  onClick?(): void;
}

export const LogoLink: FC<LogoLinkProps> = ({ children, ...props }) => (
  <Link to={HomeRoutePath.Dashboard} {...props}>
    {children}
  </Link>
);
